import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('matax_token'));

  useEffect(() => {
    if (token) {
      fetchMe();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchMe = async () => {
    try {
      const res = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(res.data);
    } catch {
      // Token invalid or expired - clear everything
      clearAuthData();
    } finally {
      setLoading(false);
    }
  };

  const clearAuthData = () => {
    // Clear all auth-related storage
    localStorage.removeItem('matax_token');
    sessionStorage.clear();
    setToken(null);
    setUser(null);
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    const { token: t, user: u } = res.data;
    localStorage.setItem('matax_token', t);
    setToken(t);
    setUser(u);
    return u;
  };

  const register = async (data) => {
    const res = await axios.post(`${API}/auth/register`, data);
    const { token: t, user: u } = res.data;
    localStorage.setItem('matax_token', t);
    setToken(t);
    setUser(u);
    return u;
  };

  // OAuth login - for Google Sign-in callback
  const loginWithOAuth = (authToken, userData) => {
    localStorage.setItem('matax_token', authToken);
    setToken(authToken);
    setUser(userData);
  };

  const logout = () => {
    // Clear all auth data
    clearAuthData();
    
    // Replace current history entry to prevent back button access
    window.history.replaceState(null, '', '/');
    
    // Force redirect to homepage
    window.location.href = '/';
  };

  const getAuthHeaders = () => ({ Authorization: `Bearer ${token}` });

  return (
    <AuthContext.Provider value={{ 
      user, 
      token, 
      loading, 
      login, 
      register, 
      loginWithOAuth,
      logout, 
      getAuthHeaders, 
      setUser,
      setToken,
      API 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
